import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';

import { useGetTokenSalesQuery } from '../api';
import type { ITokenSaleFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
  refreshInterval?: string;
}

export const useTokenSales = ({ disableUrlFilter, refreshInterval }: IProps = {}) => {
  const filter = useFilter<ITokenSaleFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  useTimezoneParam({ currentFilter, updateFilter });

  const {
    data: tokenSales,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetTokenSalesQuery(currentFilter.toString(), {
    pollingInterval:
      !refreshInterval || refreshInterval === 'off' ? undefined : parseInt(refreshInterval),
  });

  return {
    tokenSales,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
